export const GET_OKRS = 'pages/member/okr/getOkrs'
